// extracted by mini-css-extract-plugin
export default {"wrapper":"InitiatePasswordReset_wrapper__nEjsY","info":"InitiatePasswordReset_info__PAmqw","form":"InitiatePasswordReset_form__CfoEG","email":"InitiatePasswordReset_email__yUJ91"};